module.exports = __webpack_public_path__ + "img/cq1.26cd2010.png";